import { APIParser, APIParserNoMsg } from "./api-parser";
import { API_URL } from "./api-client";
import triyoAPI from "./triyo";
import { config } from "../../util/axios-config";

// Project GET
export const GetProjectTemplate = (projectQuery) => {
  if (!projectQuery.filters) projectQuery.filters = [{}];
  let projectQueryJSON = JSON.stringify(projectQuery);

  return fetch(API_URL + "GetProjectTemplate/" + "0", {
    method: "POST",
    body: projectQueryJSON,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => APIParser(response));
};

export const GetProjectTemplates = (projectQuery) => {
  let projectQueryJSON = JSON.stringify(projectQuery);
  return fetch(API_URL + "GetProjectTemplates/" + "0", {
    method: "POST",
    body: projectQueryJSON,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => {
    return APIParser(response);
  });
};

// Project Template Delete
export const DeleteProjectTemplate = async (obj) => {
  let deleteJSON = JSON.stringify(obj);
  return fetch(API_URL + "DeleteProjectTemplate/" + "0", {
    method: "POST",
    body: deleteJSON,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => APIParser(response));
};

export const GetAllProjectTemplates = () => {
  return triyoAPI.get(`/projecttemplate/GetAllProjectTemplates`, config("GET"));
};

// TASKS API CALLS

// Task Delete
export const DeleteProjectTemplateTask = async (obj) => {
  let deleteJSON = JSON.stringify(obj);
  return fetch(API_URL + "DeleteProjectTemplateTask/" + "0", {
    method: "POST",
    body: deleteJSON,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => APIParserNoMsg(response));
};

// Subtask Delete
export const DeleteProjectTemplateSubTask = async (obj) => {
  let deleteJSON = JSON.stringify(obj);
  return fetch(API_URL + "DeleteProjectTemplateSubTask/" + "0", {
    method: "POST",
    body: deleteJSON,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => APIParserNoMsg(response));
};

// Template API CALLS
export const GetAllProjectTemplatesAPI = (data) => {
  return triyoAPI.get(
    `/project-template/GetAllTemplates?filter=${JSON.stringify(data)}`,
    config("GET")
  );
};

export const GetAllProjectTemplatesForProjectsAPI = () => {
  return triyoAPI.get(
    `/project-template/GetAllTemplatesForProject`,
    config("GET")
  );
};

export const GetProjectTemplateAPI = (data) => {
  return triyoAPI.get(
    `/project-template/GetTemplateById?templateId=${data}`,
    config("GET")
  );
};

export const GetFiltersAPI = () => {
  return triyoAPI.get(`/project-template/GetFilters`, config());
};

export const CreateProjectTemplateAPI = (data) => {
  return triyoAPI.post(
    `/project-template/CreateTemplate`,
    data,
    config("POST")
  );
};

export const EditProjectTemplateAPI = (data) => {
  return triyoAPI.post(
    `/project-template/UpdateTemplate`,
    data,
    config("POST")
  );
};

export const DeleteProjectTemplateAPI = (ids) => {
  let data = { deletedIds: ids.join() };
  return triyoAPI.post(
    `/project-template/RemoveTemplate`,
    data,
    config("POST")
  );
};

// Template Task API CALLS
export const GetAllTemplateTasksAPI = (data, projectTypeId) => {
  return triyoAPI.get(
    `/project-template-task/GetAllTemplateTasks?filter=${JSON.stringify(
      data
    )}&projectTypeId=${projectTypeId}`,
    config("GET")
  );
};

export const GetTemplateTasksFiltersAPI = (data) => {
  return triyoAPI.get(
    `/project-template-task/GetTemplateTaskFilters?templateId=${data}`,
    config()
  );
};

export const GetTemplateTaskAPI = (data) => {
  return triyoAPI.get(
    `/project-template-task/GetTemplateTaskById?templateTaskId=${data}`,
    config("GET")
  );
};

export const CreateTemplateTaskAPI = (data) => {
  return triyoAPI.post(
    `/project-template-task/CreateTemplateTask`,
    data,
    config("POST")
  );
};

export const EditTemplateTaskAPI = (data) => {
  return triyoAPI.post(
    `/project-template-task/UpdateTemplateTask`,
    data,
    config("POST")
  );
};

export const UploadTemplateTaskAPI = (data) => {
  return triyoAPI.post(
    `/project-template-task/UploadTemplateTask`,
    data,
    config("POST")
  );
};

export const DeleteTemplateTaskAPI = (ids) => {
  let data = { deletedIds: ids.join() };
  return triyoAPI.post(
    `/project-template-task/RemoveTemplateTask`,
    data,
    config("POST")
  );
};

// Template Subtask API CALLS
export const CreateTemplateSubtaskAPI = (data) => {
  return triyoAPI.post(
    `/project-template/CreateTemplateSubTask`,
    data,
    config("POST")
  );
};

export const EditTemplateSubtaskAPI = (data) => {
  return triyoAPI.post(
    `/project-template/UpdateTemplateSubTask`,
    data,
    config("POST")
  );
};

export const GetDefaultTemplateForProject = () => {
  return triyoAPI.get("/project-template/GetDefaultTemplate", config());
}
